import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from 'registerServiceWorker';
import reportWebVitals from 'reportWebVitals';

import Root from 'components/core/Root.component';
import Poc from 'components/experiment/poc/Poc.component';
import CONF from 'config/conf.singleton';
import PUSHER from 'config/pusher.singleton';
import SCAN from 'config/scan.singleton';
import SEGMENT from 'config/segment.singleton';
import SENTRY from 'config/sentry.singleton';
import SLICK from 'config/slick.singleton';
import disableDoubleTouch from 'utils/core/disableDoubleTouch.util';

import createVisibilityChangeListener from 'lib/createVisibilityChangeListener';

import 'i18n';

import 'styles/app.scss';
import 'styles/v2/index.scss';

/**
 * Helps with WebStorm misunderstanding the types of UseState e.g. where mixed string and undefined are allowed
 * @typedef {(init:((()=>*)|*))=>(function(*):*)} UseState
 * */

/**
 * Helps with WebStorm misunderstanding the type of VariadicV e.g. console.log taking any number of arguments
 * @typedef {function(...*):void} VariadicV
 * */

const CTAG = '[INDEX]';
const logW = /**@type VariadicV*/ console.warn.bind(console, '[W]', CTAG); // eslint-disable-line no-console,no-unused-vars
const logI = /**@type VariadicV*/ console.info.bind(console, '[I]', CTAG); // eslint-disable-line no-console,no-unused-vars

window.addEventListener(
  'unhandledrejection',
  (ev) => void logW('window.on(unhandledrejection)', 'reason:', ev?.reason, 'ev:', ev),
);

if (String(window.location.pathname).startsWith('/poc/')) {
  logI('[INIT-RELATED]', 'POC Page pathname:', window.location.pathname);
  // noinspection JSCheckFunctionSignatures
  ReactDOM.render(React.createElement(Poc), SLICK.root);
} else {
  logI('[INIT-RELATED]', 'location:', String(window.location));

  window.SLICK = SLICK;

  try {
    SENTRY.init(CONF);
  } catch (e) {
    logW('[INIT-RELATED]', 'SENTRY error:', e);
  }

  SEGMENT.init(CONF);
  SCAN.init(CONF).catch((e) => logW('[INIT-RELATED]', 'SCAN error:', e));
  PUSHER.init(CONF);

  if (SLICK.root) {
    // noinspection JSCheckFunctionSignatures
    ReactDOM.render(React.createElement(Root), SLICK.root);
  }

  registerServiceWorker(CONF);
  disableDoubleTouch();

  (() => {
    const visibilityChangeListener = createVisibilityChangeListener({ granularity: 9999, subscribe: false });
    document.addEventListener('visibilitychange', visibilityChangeListener);
    // this extra call ensures the listeners are catching events after a page reload while visibility hasn't changed
    visibilityChangeListener();
  })();

  // If you want to start measuring performance, pass a function to log results
  // (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://create-react-app.dev/docs/measuring-performance/
  reportWebVitals();
}
